import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Routes from './routes';
import Loader from './shared/components/Loader/Loader';
import newrelic from "./shared/utilities/newrelic";


import {
  logJSError,
  logNewrelicNoticeError
} from "./shared/utilities/logger";
import util from "./shared/utilities/util";
import { library,ErrorBoundary,SessionTimeoutModal, libLogger } from "@vz/react-util";
export const history = createBrowserHistory();

const loaderImg = (<Loader/>);

class App extends Component {
  constructor(props) {
    super(props);
  }
  componentWillMount() {
   /* try {
      if (typeof (newrelic) != "undefined" && typeof (newrelic.setCustomAttribute) != "undefined") {
        newrelic.setCustomAttribute("channelId", util.getChannelId());
        newrelic.setCustomAttribute("nsaSessionId", typeof (_dg_sessid) != "undefined" ? _dg_sessid : "");
      }
    } catch (ex) { } */
    // setTimeout(function () {
    //   util.getChunkFilename();
    // }, 2000);
    
  }
  componentDidMount() {
    // newrelic.pageInitialization();
    library.init({
      appName: 'INTL', pageName: 'International Landing', newRelic: {
        apiEndpointsToMeasure: ['landing_page', 'destination_list', 'get_travel_dates', 'get_devices',
          'get_plans', 'review_plan', 'select_effective_date', 'submit_offers', 'country_list_byplan', 'feature_comparison',
          'review_plan', 'removeplan', 'removeplaneffectivedate', 'removeplanreview', 'removeplanconfirmation', 'cancelorder', 'pendingorder', 
          'device_compatibility_check', 'get_effective_dates', 'remarksSelection', 'generateOrSkipRemarks', 'reptool', 'app_landingPage', 'statementDetails', 'usage_Details']
      },
    });
    // window.addEventListener("error", this.handleError);
    window.addEventListener("hashchange", this.handleHashChange);

  }

  componentWillUnmount() {
    // window.removeEventListener("error", this.handleError);
    window.removeEventListener("hashchange", this.handleHashChange);
  }
  handleHashChange = e => {
   /* try {
      newrelic.pageInitialization();
    } catch (ex) { }
*/
  };
  
  render() {
    return (
      <Suspense fallback={loaderImg}>
        <HashRouter history={history}>
        <ErrorBoundary init={true}>
                <Routes reduxStore={this.props.reduxStore} />
                    { !util.isUnAuth()
                      && (
                        <SessionTimeoutModal />
                      )
                    }
                  </ErrorBoundary>
       
          {/* <div className="App">
            <div className="App-header">
              <h2>International Project</h2>
            </div>
          </div> */}
        </HashRouter>
      </Suspense>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    reduxStore: store
  }
};

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
